export const LIST = "MEMBER_PROMOTION_LIST";
export const UPDATE = "MEMBER_PROMOTION_UPDATE";
export const DETAILS = "MEMBER_PROMOTION_DETAILS";